// src/api/rates.ts
import { opsHttp } from "../auth/apiClient.ts";

/** Курс фиатной валюты к USDT: сколько единиц валюты за 1 USDT. */
export interface FiatRateDto {
  currency: string;
  name: string;
  /** Единиц валюты за 1 USDT, напр. 453.66 ₸ */
  rate: number;
  isCis: boolean;
}

export interface FiatRatesResponse {
  rates: FiatRateDto[];
  fetchedAt: string;
  /** true — курсы из кеша, источник сейчас недоступен. */
  stale: boolean;
}

/** Справочник курсов фиата к USDT. Используется для подстановки курса при создании заявки. */
export async function getFiatRates(): Promise<FiatRatesResponse> {
  const { data } = await opsHttp.get<FiatRatesResponse>("/api/Rates/fiat");
  return data ?? { rates: [], fetchedAt: "", stale: true };
}
